module.exports = __webpack_public_path__ + "static/media/subGoogle3.9d31ad3a.png";